module.exports = __webpack_public_path__ + "static/media/LandingPageBackground01.a11238ac.png";